module.exports = __webpack_public_path__ + "img/webclass.72a01e0.svg";